import PropTypes from 'prop-types';

export const StudentSurveyPermission = PropTypes.shape({
    roleId: PropTypes.number.isRequired,
    canView: PropTypes.bool,
    canEdit: PropTypes.bool
});
